export const External_left_list = [{
		id: 0,
		store_id: 0,
		field: "单行文字",
		field_type: 1,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	},
	{
		id: 0,
		store_id: 0,
		field: "多行文字",
		field_type: 2,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	}, {
		id: 0,
		store_id: 0,
		field: "日期",
		field_type: 3,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	}, {
		id: 0,
		store_id: 0,
		field: "数字",
		field_type: 4,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	}, {
		id: 0,
		store_id: 0,
		field: "单项选择",
		field_type: 5,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	}, {
		id: 0,
		store_id: 0,
		field: "多项选择",
		field_type: 6,
		field_config: {
			list: [],
		},
		type: 1,
		is_state: 1,
		lock: 0,
		is_module: 1,
		sort: 1,
		module_detail_type: 0,
		length: 0,
		placeholder: "请输入",
		maxlength: 0,
		required: 0,
		group_id: 0,
		is_move: 0,
		value: "",
		projcet_div_id: 1,
		is_table: 0,
		table_sort: 0,
		operate: 2
	}, ]
	
export const External_feildSelect = [
		{
			title: '单行文字',
			type: 1,
		},
		{
			title: '多行文本',
			type: 2,
		},
		{
			title: '日期',
			type: 3,
		},
		{
			title: '数字',
			type: 4,
		},
		{
			title: '单项选择',
			type: 5,
		},
		{
			title: '多项选择',
			type: 6,
		},
	]